import { Link } from 'react-router-dom';
import { categories, articles, featuredArticles, faqItems, usageGuideSteps, siteInfo } from '@/mocks/siteData';
import { useState } from 'react';
import { get_form_url } from '@/utils/form';

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const featured = articles.filter((a) => featuredArticles.includes(a.id));

  return (
    <>
      <main>
        <section className="relative h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20golden%20and%20rose%20abstract%20gradient%20background%20with%20soft%20flowing%20curves%2C%20elegant%20literary%20atmosphere%2C%20books%20and%20pages%20floating%20in%20ethereal%20light%2C%20minimalist%20artistic%20composition%2C%20clean%20dreamy%20aesthetic%2C%20no%20text&width=1600&height=900&seq=hero-po18-01&orientation=landscape"
            alt="po18阅读平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-3xl mx-auto">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
                po18官方入口
              </h1>
              <p className="mt-4 md:mt-6 text-base md:text-lg text-white/80 font-body max-w-2xl mx-auto leading-relaxed">
                po18是深受用户喜爱的内容阅读平台，提供po18最新官方入口、备用地址及使用指南，帮助用户快速访问po18，畅享海量优质内容资源
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href={siteInfo.officialUrl}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white text-base font-label font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  进入po18官方入口
                  <i className="ri-arrow-right-up-line ml-2"></i>
                </a>
                <Link
                  to="/category/yanqing"
                  className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white text-base font-label font-medium rounded-lg hover:bg-white/25 transition-colors whitespace-nowrap border border-white/20 cursor-pointer"
                >
                  浏览内容分类
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                po18最新地址导航
              </h2>
              <p className="mt-3 text-foreground-500 font-body max-w-xl mx-auto">
                收藏本页获取po18实时更新地址，以下为当前可用入口
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-background-50 border border-primary-200 rounded-xl p-6 text-center hover:border-primary-400 transition-colors">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-link text-2xl text-primary-600"></i>
                </div>
                <div className="text-xs text-foreground-400 font-label mb-1">官方主站</div>
                <a
                  href={siteInfo.officialUrl}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-sm font-label font-medium text-primary-600 hover:text-primary-500 transition-colors break-all"
                >
                  {siteInfo.officialUrl.replace('https://', '')}
                </a>
                <div className="mt-2 inline-flex items-center gap-1 px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-label rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                  正常访问
                </div>
              </div>
              {siteInfo.backupUrls.map((url, i) => (
                <div key={i} className="bg-background-100 rounded-xl p-6 text-center hover:bg-background-200/70 transition-colors">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                    <i className="ri-link-m text-2xl text-secondary-600"></i>
                  </div>
                  <div className="text-xs text-foreground-400 font-label mb-1">备用地址 {i + 1}</div>
                  <a
                    href={url}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-sm font-label font-medium text-foreground-700 hover:text-primary-600 transition-colors break-all"
                  >
                    {url.replace('https://', '')}
                  </a>
                  <div className="mt-2 inline-flex items-center gap-1 px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-label rounded-full">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                    可用
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                如何使用po18
              </h2>
              <p className="mt-3 text-foreground-500 font-body max-w-xl mx-auto">
                只需四步，轻松开启po18阅读之旅
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {usageGuideSteps.map((step) => (
                <div key={step.step} className="relative bg-background-50 rounded-xl p-6 text-center">
                  <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className={`${step.icon} text-2xl text-primary-600`}></i>
                  </div>
                  <div className="absolute -top-3 -left-3 w-8 h-8 rounded-full bg-accent-500 text-white flex items-center justify-center text-sm font-label font-bold">
                    {step.step}
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900">{step.title}</h3>
                  <p className="mt-2 text-sm text-foreground-500 font-body">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  内容分类
                </h2>
                <p className="mt-2 text-foreground-500 font-body">探索po18丰富的阅读世界</p>
              </div>
              <Link to="/category/yanqing" className="hidden sm:inline-flex items-center gap-1 text-sm font-label text-primary-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-300 transition-all duration-200 cursor-pointer"
                >
                  <div className="w-11 h-11 rounded-lg bg-primary-50 flex items-center justify-center mb-3 group-hover:bg-primary-100 transition-colors">
                    <i className={`${cat.icon} text-xl text-primary-600`}></i>
                  </div>
                  <h3 className="text-sm font-label font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors">{cat.name}</h3>
                  <p className="mt-1 text-xs text-foreground-400 font-body">{cat.count.toLocaleString()} 部作品</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  编辑精选
                </h2>
                <p className="mt-2 text-foreground-500 font-body">po18平台最受欢迎的热门作品</p>
              </div>
              <Link to="/category/yanqing" className="hidden sm:inline-flex items-center gap-1 text-sm font-label text-primary-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                更多推荐 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {featured.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`${article.title} - po18阅读平台热门推荐`}
                    />
                  </div>
                  <div className="p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-label rounded-full">
                        {categories.find((c) => c.slug === article.category)?.name}
                      </span>
                      <span className="text-xs text-foreground-400 font-body">{article.views.toLocaleString()} 阅读</span>
                    </div>
                    <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-xs text-foreground-500 font-body line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                常见问题
              </h2>
              <p className="mt-3 text-foreground-500 font-body">关于po18的常见疑问解答</p>
            </div>
            <div className="flex flex-col gap-3">
              {faqItems.map((faq, i) => (
                <div key={i} className="bg-background-100 rounded-xl overflow-hidden">
                  <button
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  >
                    <span className="text-sm font-label font-medium text-foreground-800">{faq.question}</span>
                    <i className={`ri-${openFaq === i ? 'subtract' : 'add'}-line text-lg text-foreground-400 transition-transform duration-200`}></i>
                  </button>
                  {openFaq === i && (
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 font-body leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-950 text-background-200">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
              收藏本页，随时访问po18
            </h2>
            <p className="mt-4 text-background-400 font-body leading-relaxed max-w-xl mx-auto">
              将本导航页加入浏览器收藏夹，即可随时获取po18最新官方入口地址和备用网址，畅享海量优质阅读内容
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={siteInfo.officialUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white text-base font-label font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即访问po18
                <i className="ri-arrow-right-up-line ml-2"></i>
              </a>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-800 text-background-100 text-base font-label font-medium rounded-lg hover:bg-background-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
